












































import {Component, Vue} from "vue-property-decorator"
import JdsCandidateBubble from "@/design-system/constructs/CandidateBubble/JdsCandidateBubble.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdiHeading from "@/components/JdiHeading.vue"
import JdiContent from "@/components/JdiContent.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsJobTile from "@/design-system/constructs/JobTile/JdsJobTile.vue"
import JdsJobTileListLayout from "@/design-system/constructs/JobTile/JdsJobTileListLayout.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import {
    Job,
    JobStatus,
    JobCampaignStatus,
} from "@/design-system/constructs/JobTile/JobTileViewModel"

@Component({
    components: {
        JdiDocs,
        JdsJobTileListLayout, JdsJobTile, JdsCandidateBubble, JdiStatus, JdiHeading, JdiContent, JdiPreview}
})
export default class JobTile extends Vue {
    job: Job = {
        title: 'Senior Dev',
        location: 'London',
        activeFrom: '2021-01-10T11:30:10+00:00',
        activeTo: null,
        status: JobStatus.OPEN,
        campaignStatus: JobCampaignStatus.SCHEDULED,
        numberOfUnreadMails: 0,
        pipeline: {
            entry: 12,
            other: 5,
            hire: 0,
            rejection: 9,
        },
        isStarred: false,
        isArchived: false,
        isHidden: false,
        subscribers: [
            {
                id: 24,
                name: 'Great recruiter',
                avatar: '',
            },
            {
                id: 25,
                name: 'Best recruiter',
                avatar: '',
            },
        ]
    }

    toggleIsStarred() {
        this.job.isStarred = !this.job.isStarred;
    }
}
